import { render } from "./MyPageOrder.vue?vue&type=template&id=a1244050"
import script from "./MyPageOrder.vue?vue&type=script&lang=js"
export * from "./MyPageOrder.vue?vue&type=script&lang=js"

import "./MyPageOrder.vue?vue&type=style&index=0&id=a1244050&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__